import types from "../actionTypes";
import invitationsService from "../../services/invitations.service";

export const createInvitation =
  ({ discoveryId, emails }) =>
  (dispatch) => {
    dispatch({
      type: types.CREATE_INVITATION_REQUEST
    });

    return invitationsService
      .createInvitation({
        discoveryId,
        emails
      })
      .then((invitation) => {
        dispatch({
          type: types.CREATE_INVITATION_SUCCESS,
          payload: invitation
        });
      })
      .catch((error) => {
        dispatch({
          type: types.CREATE_INVITATION_FAILURE,
          payload: { error }
        });
      });
  };

export const getInvitation =
  ({ invitationId }) =>
  (dispatch) => {
    dispatch({
      type: types.GET_INVITATION_REQUEST
    });

    return invitationsService
      .getInvitation({
        invitationId
      })
      .then((invitation) => {
        dispatch({
          type: types.GET_INVITATION_SUCCESS,
          payload: { invitation }
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_INVITATION_FAILURE,
          payload: { error }
        });
      });
  };
